module.exports = __webpack_public_path__ + "b2ffe02531981edb8861898c38af1574.png";